import { useApi } from './useApi';
import { NavigationData } from '../types/api';

export function useNavigation() {
  const { data, loading, error, refetch } = useApi<NavigationData>('/navigation/primary.json');
  
  return {
    navigation: data,
    loading,
    error,
    refetch,
  };
}

export default useNavigation;
